import { render, staticRenderFns } from "./ListPresentations.vue?vue&type=template&id=783d1b4f&scoped=true&"
import script from "./ListPresentations.vue?vue&type=script&lang=js&"
export * from "./ListPresentations.vue?vue&type=script&lang=js&"
import style0 from "./ListPresentations.vue?vue&type=style&index=0&id=783d1b4f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "783d1b4f",
  null
  
)

export default component.exports